import React from 'react';
import { useTranslation } from 'react-i18next';
import './SpeakerBadge.css';
import speakerIcon from './../../../assets/icons/ui/speaker.svg';

interface SpeakerBadgeProps {
  speakersName: string;
  link: string;
}

const SpeakerBadge: React.FC<SpeakerBadgeProps> = ({ speakersName, link }) => {
  const { t } = useTranslation();

  return (
    <a href={link} className="speaker-badge">
      <img src={speakerIcon} alt="Speaker" className="speaker-icon" />
      <span style={{ fontWeight: '400' }}>{t("speaker")}:&nbsp;</span> {speakersName}
    </a>
  );
};

export default SpeakerBadge;
